import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';
import {
  disconnectIntegration,
  fetchIntegrations,
} from '../../../services/queries/MaggieIntegrationsQueries';

import { integrationsState } from '../state/IntegrationsState';

export function useIntegrationActions() {
  const disconnect = useAtomCallback(
    useCallback(async (get, set, integrationId: number) => {
      const previous = (await get(integrationsState)) ?? [];
      const optimistic = previous.map((integration) =>
        integration.id === integrationId ? { ...integration, isConnected: false } : integration
      );
      set(integrationsState, optimistic);

      try {
        await disconnectIntegration(integrationId);
      } catch (error) {
        console.error(error);
        set(integrationsState, previous);
      }
    }, [])
  );

  const refetchIntegrations = useAtomCallback(
    useCallback(async (_get, set) => {
      const integrations = await fetchIntegrations();
      set(integrationsState, integrations);
    }, [])
  );

  return {
    disconnect,
    refetchIntegrations,
  };
}
